const map = {
	"./ar/virtual.jpg": 98789,
	"./de/virtual.jpg": 76925,
	"./en/virtual.jpg": 25013,
	"./fr/virtual.jpg": 30956,
	"./it/virtual.jpg": 64460,
	"./kh/virtual.jpg": 48385,
	"./krt/virtual.jpg": 11755,
	"./nl/virtual.jpg": 27022,
	"./tr/virtual.jpg": 54034
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62045;